import { ActionTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { IApartmentState } from './apartment-state.store';
import {
  APARTMENT_GET_APPARTMENTS_MASTER,
  APARTMENT_SET_APPARTMENTS_MASTER,
  APARTMENT_GET_APPARTMENTS,
  APARTMENT_SET_APPARTMENTS,
  APARTMENT_GET_APPARTMENT,
  APARTMENT_LOADING,
  APARTMENT_SET_APPARTMENT,
  APARTMENT_SET_PARAMETER,
  APARTMENT_GET_SIDEBAR_APPARTMENTS,
  APARTMENT_SET_SIDEBAR_APPARTMENTS,
  APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE,
  APARTMENT_GET_BLOCK_APPARTMENTS_AUTOCOMPLETE,
  APARTMENT_RECORD_APPARTMENT,
  APARTMENT_INIT_APPARTMENT,
  APARTMENT_RESET_APPARTMENT,
  APARTMENT_EDIT_APARTMENT,
  APARTMENT_ACTION,
  APARTMENT_UPDATE_APARTMENT,
  APARTMENT_DELETE_APARTMENT,
  APARTMENT_RECORD_LOCATION_NUMBER,
  APARTMENT_SET_LOCATION_NUMBER,
  APARTMENT_GET_ZONE,
  APARTMENT_SET_ZONE,
  APARTMENT_POST_ZONE, APARTMENT_PATCH_ZONE, APARTMENT_DELETE_ZONE, APARTMENT_SEARCH_ZONE
} from './apartment-types.store';
import { ActivityStatus, UserTypes, CrudStatus } from '../../common/enums';
import { IApartmentParameter, ApartmentParameter, IApartment } from '../../models/apartment';
import { IApartmentService } from '../../services';
import {AddressDto} from "../../models/address/address.model";

export const actions: ActionTree<IApartmentState, IRootState> = {
  [APARTMENT_RECORD_APPARTMENT] : async ({ state, commit, getters }, payload : { keepAlive?: boolean } ): Promise<any> => {
     const service: IApartmentService= getters.service
     return service.recordApartment(getters.apartment)
        .then(createdApartment=>{
          if(!payload.keepAlive) commit(APARTMENT_INIT_APPARTMENT, service.initApartment())
          else {
            const { num_apartment, ...restOpts } = getters.apartment
            commit(APARTMENT_INIT_APPARTMENT,service.initApartment({
              ...restOpts
            }))
          }
          Promise.resolve(createdApartment)
        })
        .catch(error => Promise.reject(error))
  },
  [APARTMENT_UPDATE_APARTMENT] : async ({ commit, getters }) : Promise<any> => {
    const service: IApartmentService= getters.service
    const apartment: IApartment = getters.apartment

    return service.updateApartment(getters.currentApartment.id,apartment.block,apartment)
        .then(updatedApartment => {
          commit(APARTMENT_INIT_APPARTMENT,service.initApartment())
          commit(APARTMENT_ACTION,CrudStatus.NoAction)
          commit(APARTMENT_SET_APPARTMENT, updatedApartment)
           return Promise.resolve(updatedApartment)
        })
        .catch(err=> Promise.reject(err) )
  },
  [APARTMENT_DELETE_APARTMENT] : async ({commit,getters}) : Promise<any> => {
    const service: IApartmentService= getters.service
    const apartment_id: number= getters.currentApartment.id
    return service.deleteApartment(apartment_id)
      .then( deletedApartment => {
        return Promise.resolve(deletedApartment)
      })
      .catch( err => Promise.reject(err) )
      .finally(() => commit(APARTMENT_ACTION, CrudStatus.NoAction) )
  },
  [APARTMENT_RESET_APPARTMENT]: ({ commit, state }) => {
    const service: IApartmentService = state.service
    commit(APARTMENT_INIT_APPARTMENT, service.initApartment())
    commit(APARTMENT_ACTION, CrudStatus.NoAction)
  },
  [APARTMENT_EDIT_APARTMENT] : ({ commit, state }) => {
    const service: IApartmentService= state.service
    const currentApartment: any= state.currentApartment

    const {tenants,owners} = currentApartment

    commit(APARTMENT_ACTION,CrudStatus.Update)
    commit(APARTMENT_INIT_APPARTMENT,service.initApartment({
      num_apartment: currentApartment.apartment_number,
      ... tenants && tenants.length && { tenant: currentApartment.tenants.map(tenant=> tenant.id) },
      ... owners && owners.length && { owner: currentApartment.owners.map(owner => owner.id) },
      floor: currentApartment.floor ,
      surface: currentApartment.square_meter,
      type: currentApartment.type,
      apartment_as_block: currentApartment.apartment_as_block ? {
        ...currentApartment.apartment_as_block,
        maintenance_referents: currentApartment.maintenance_referents.map(x => x.id),
        vehicle_referents: currentApartment.vehicle_referents.map(x => x.id),
        address: new AddressDto(currentApartment.apartment_as_block.address)
      } : null
    }))
  },
  [APARTMENT_GET_APPARTMENTS_MASTER]: async ({ state, commit, rootGetters }, param) => {
    if (state.apartments !== null) return;


    if (rootGetters['user/userInfo'] && rootGetters['user/userInfo'].type !== UserTypes.Manager) {
      if (rootGetters['user/userInfo'].apartments) {
        commit(APARTMENT_SET_APPARTMENTS_MASTER, {
          activityStatus: ActivityStatus.Loading,
          apartments: rootGetters['user/userInfo'].apartments || []
        });
        return Promise.resolve(rootGetters['user/userInfo'].apartments)
      }
    }

    return state.service.getApartments(param)
      .then(apartments => {
        commit(APARTMENT_SET_APPARTMENTS_MASTER, {
          activityStatus: ActivityStatus.Loaded,
          apartments
        })
      })
      .catch(error => console.log(error));
  },
  [APARTMENT_GET_APPARTMENTS]: async ({ state, commit }, payload: { blockId: string, merge: boolean, param: IApartmentParameter }) => {

    if (state.activityStatus === ActivityStatus.Loading) return;
    commit(APARTMENT_LOADING, ActivityStatus.Loading);
    if (payload.param)
      commit(APARTMENT_SET_PARAMETER, payload.param);
    return state.service.getBlockAppartments(payload.blockId, payload.param, payload.merge)
      .then(rawData => {
        commit(APARTMENT_SET_APPARTMENTS, {
          apartments: rawData.data,
          pagination: { total: rawData.total, skip: rawData.skip, limit: rawData.limit },
          merge: payload.merge
        })
        return rawData.data;
      })
      .catch(error => {
        commit(APARTMENT_LOADING, ActivityStatus.LoadFailed)
      });
  },
  [APARTMENT_GET_SIDEBAR_APPARTMENTS]: async ({ state, commit }, blockId: string) => {

    return state.service.getBlockAppartments(blockId,
      new ApartmentParameter({ $limit: 3 }))
      .then(rawData => {
        commit(APARTMENT_SET_SIDEBAR_APPARTMENTS, rawData.data)
        return rawData.data;
      })
      .catch(error => {
        commit(APARTMENT_LOADING, ActivityStatus.LoadFailed)
      });
  },
  [APARTMENT_GET_APPARTMENT]: async ({ state, commit }, payload: { blockId: string, apartmentId: string }) => {
    commit(APARTMENT_LOADING, ActivityStatus.Loading)

    return state.service.getBlockApartmentById(payload.blockId, payload.apartmentId)
      .then(apartment => {
        commit(APARTMENT_SET_APPARTMENT, apartment);
        return Promise.resolve(apartment);
      })
      .catch(error => {
        commit(APARTMENT_LOADING, ActivityStatus.LoadFailed);
        console.log(error);
      })
  },
  [APARTMENT_GET_ZONE]: async ({state, commit}, payload: { apartmentId: string }) => {
    return state.service.getApartmentZones(payload.apartmentId)
      .then(zones => {
        commit(APARTMENT_SET_ZONE, zones)
        return Promise.resolve(zones);
      })
      .catch(error => {
        console.log(error);
      })
  },
  [APARTMENT_SEARCH_ZONE]: async ({state, commit}, payload: { apartments: number[], q: string }) => {
    return state.service.searchAptZones(payload)
      .then(zones => {
        // commit(APARTMENT_SET_ZONE, zones)
        return Promise.resolve(zones);
      })
      .catch(error => {
        console.log(error);
      })
  },
  [APARTMENT_POST_ZONE]: async ({state, commit}, payload: {apartmentId: string, params: any}) => {
    return state.service.postApartmentZones(payload.apartmentId, payload.params)
      .then(zones => {
        commit(APARTMENT_SET_ZONE, state.currentApartmentZone.concat([zones]))
        return Promise.resolve(zones);
      })
      .catch(error => {
        console.log(error);
      })
  },
  [APARTMENT_PATCH_ZONE]: async ({state, commit}, payload: {apartmentId: string, zoneId: string, params: any}) => {
    return state.service.patchApartmentZones(payload.apartmentId, payload.zoneId, payload.params)
      .then(zone => {
        commit(APARTMENT_SET_ZONE, state.currentApartmentZone.map(x => {
          if (x.id === zone.id) x = zone
          return x
        }))
        return Promise.resolve(zone);
      })
      .catch(error => {
        console.log(error);
      })
  },
  [APARTMENT_DELETE_ZONE]: async ({state, commit}, payload: {apartmentId: string, zoneId: string}) => {
    return state.service.deleteApartmentZones(payload.apartmentId, payload.zoneId)
      .then(zone => {
        commit(APARTMENT_SET_ZONE, state.currentApartmentZone.filter(x => x.id !== zone.id))
        return Promise.resolve(zone);
      })
      .catch(error => {
        console.log(error);
      })
  },
  [APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE]: async ({ state, commit }, payload: { blockId: number, entity: number[], key: string, limit: number, external:boolean }) => {
    commit(APARTMENT_LOADING, ActivityStatus.Loading)
    const param = new ApartmentParameter()
    if (payload.blockId) {
      param.block = payload.blockId
    }
    if (payload.entity) {
      param.entity = payload.entity
    }

    if (payload.external) {
      param.external = payload.external
    }

    if (payload.key) {
      param.key = payload.key
    }
    param.$limit = payload.limit | 50 // Number.MAX_SAFE_INTEGER;

    return state.service.getApartments(param, true)
      .then(rawData => {
        commit(APARTMENT_LOADING, ActivityStatus.Loaded)
        return Promise.resolve(rawData.data);
      })
      .catch(error => {
        commit(APARTMENT_LOADING, ActivityStatus.LoadFailed);
        console.log(error);
        return error;
      })
  },
  [APARTMENT_GET_BLOCK_APPARTMENTS_AUTOCOMPLETE]: async ({ state, commit }, payload: { blockId: string, entity: string, key: string }) => {
    commit(APARTMENT_LOADING, ActivityStatus.Loading)

    const param: IApartmentParameter = new ApartmentParameter({ $limit: Number.MAX_SAFE_INTEGER });

    if (payload.entity) {
      param.entity = payload.entity
    }

    if (payload.key) {
      param.key = payload.key
    }

    return state.service.getBlockAppartments(payload.blockId, param, true)
      .then(rawData => {
        commit(APARTMENT_LOADING, ActivityStatus.Loaded)
        return Promise.resolve(rawData.data);
      })
      .catch(error => {
        commit(APARTMENT_LOADING, ActivityStatus.LoadFailed);
        console.log(error);
        return error;
      })
  },
  [APARTMENT_RECORD_LOCATION_NUMBER]: async ({ state, commit }, payload: { blockId: string, apartmentId: string, locationNumber: string }) => {

    commit(APARTMENT_LOADING, ActivityStatus.Loading)

    return state.service.createLocationNumber(payload.blockId, payload.apartmentId, state.currentApartment.location_number, payload.locationNumber)
      .then(apartment => {
        commit(APARTMENT_SET_LOCATION_NUMBER, apartment);
        return Promise.resolve(apartment);
      })
      .catch(error => {
        commit(APARTMENT_LOADING, ActivityStatus.LoadFailed);
        console.log(error);
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/apartment/apartment-actions.store.ts